import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, Injectable } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { MyApp } from './app.component';
import { LoginPage } from '../pages/login/login';
import { HomePage } from '../pages/home/home';
import { LoginPageModule } from '../pages/login/login.module';
import { ForgotPasswordPageModule } from './../pages/forgot-password/forgot-password.module';
import { SurveyPageModule } from '../pages/survey/survey.module';
import { SurveyAccomplishPageModule } from '../pages/survey-accomplish/survey-accomplish.module';
import { SurveyMenuPageModule } from '../pages/survey-menu/survey-menu.module';
import { DocrenPageModule } from '../pages/docren/docren.module';
import { FilePreviewPageModule } from '../pages/docren/file-preview.module';
import { TrainingPageModule } from '../pages/training/training.module'
import { TrainingDetailsPageModule } from '../pages/training-details/training-details.module';
import { BrainstormPageModule } from '../pages/brainstorm/brainstorm.module';
import { BrainstormListPageModule } from './../pages/brainstorm-list/brainstorm-list.module';
import { IntermarketingPageModule } from '../pages/intermarketing/intermarketing.module';
import { IntermarketingDetailsPageModule } from './../pages/intermarketing-details/intermarketing-details.module';
import { NotificationPageModule } from '../pages/notification/notification.module';
import { CronosProjectsPageModule } from './../pages/cronos-projects/cronos-projects.module';
import { CronosListsPageModule } from './../pages/cronos-lists/cronos-lists.module';
import { CronosActionPageModule } from './../pages/cronos-action/cronos-action.module';
import { CronosPopoverPageModule } from '../pages/cronos-popover/cronos-popover.module';
import { CronosFilePageModule } from '../pages/cronos-file/cronos-file.module';
import { CronosMembersPageModule } from './../pages/cronos-members/cronos-members.module';
import { CronosMembersAddPageModule } from '../pages/cronos-members-add/cronos-members-add.module';
import { CronosCategoriesPageModule } from './../pages/cronos-categories/cronos-categories.module';
import { CronosCategoryFormPageModule } from './../pages/cronos-category-form/cronos-category-form.module';
import { CronosFilterPageModule } from './../pages/cronos-filter/cronos-filter.module';
import { PartnerPageModule } from './../pages/partner/partner.module';
import { EvaluationsPageModule } from '../pages/avalicorp/evaluations.module';
import { RealizeEvaluationPageModule } from '../pages/avalicorp-realize-evaluation/realize-evaluation.module';

import { UserService } from './../services/UserService';
import { SurveyService } from '../services/SurveyService';
import { DocrenService } from '../services/docren-service';
import { TrainingService } from '../services/TrainingSevice';
import { BrainstormService } from '../services/BrainstormService';
import { NotificationService } from '../services/NotificationService';
import { CronosService } from '../services/CronosService';
import { EvaluationService } from '../services/evaluation-service';
import { RealizeEvaluationService } from '../services/realize-evaluation-service';
import { HttpSecurityTimeoutInterceptor } from '../services/HttpSecurityTimeoutInterceptor';

import { UserEffects } from '../store/effects/UserEffects';
import { SurveyEffects } from './../store/effects/SurveyEffects';
import { TrainingEffects } from '../store/effects/TrainingEffects';
import { NotificationEffects } from './../store/effects/NotificationEffects';
import { BrainstormEffects } from './../store/effects/BrainstormEffects';
import { CronosEffects } from './../store/effects/CronosEffects';
import { metaReducers, reducers } from '../store/AppStore';

import * as Sentry from "@sentry/browser";
Sentry.init({
  dsn: "https://2286e4a982fc4753b81f13da487a52d6@sentry.io/1284534"
});

@Injectable()
export class SentryErrorHandler extends IonicErrorHandler {
  handleError(error) {
    super.handleError(error);
    try {
      Sentry.captureException(error.originalError || error);
    } catch (e) {
      console.error(e);
    }
  }
}

@NgModule({
  declarations: [
    MyApp,
    HomePage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    LoginPageModule,
    NotificationPageModule,
    ForgotPasswordPageModule,
    SurveyPageModule,
    SurveyAccomplishPageModule,
    SurveyMenuPageModule,
    DocrenPageModule,
    FilePreviewPageModule,
    TrainingPageModule,
    TrainingDetailsPageModule,
    BrainstormPageModule,
    BrainstormListPageModule,
    IntermarketingPageModule,
    IntermarketingDetailsPageModule,
    CronosProjectsPageModule,
    CronosListsPageModule,
    CronosActionPageModule,
    CronosPopoverPageModule,
    CronosFilePageModule,
    CronosMembersPageModule,
    CronosMembersAddPageModule,
    CronosCategoriesPageModule,
    CronosCategoryFormPageModule,
    CronosFilterPageModule,
    PartnerPageModule,
    EvaluationsPageModule,
    RealizeEvaluationPageModule,
    IonicModule.forRoot(MyApp, {
      scrollAssist: false,
      autoFocusAssist: false,
      platforms: {
        ios: {
          backButtonText: 'Voltar'
        }
      }
    }),
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([UserEffects, SurveyEffects, TrainingEffects, BrainstormEffects, NotificationEffects, CronosEffects])
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LoginPage,
    HomePage
  ],
  providers: [
    StatusBar,
    SplashScreen,

    UserService,
    SurveyService,
    DocrenService,
    TrainingService,
    BrainstormService,
    NotificationService,
    CronosService,
    EvaluationService,
    RealizeEvaluationService,
    { provide: ErrorHandler, useClass: SentryErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: HttpSecurityTimeoutInterceptor, multi: true }
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts